module.exports = __webpack_public_path__ + "img/bg-page.2ed47297.png";